import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Divider } from "rsuite";
import Swal from "sweetalert2";
import { calculateBMI } from "../../utils/helper.js";
import CheckboxGroupInput from "../common/CheckboxGroupInput.tsx";
import SelectInput from "../common/SelectInput.tsx";
import ReviveAdultPolicyForm from "./ReviveAdultPolicyForm.tsx";

const ReviveChildPolicy = ({
  onSubmit,
  gender,
}: {
  onSubmit: (data: any) => void;
  gender: string;
}) => {
  debugger;
  const form = useFormContext();
  const isPregnant = form.watch("isPregnant");
  const hasChildren = form.watch("hasChildren") === ("true" as unknown);
  const isNormalDelivery = form.watch("deliveryType") === "normal";
  const hasAbortion = form.watch("hasAbortion") === ("true" as unknown);

  const height = form.watch("childHeight");
  const heightInch = form.watch("childHeightInch");
  const weight = form.watch("childWeight");

  const proposerHeight = form.watch("proposerHeight");
  const proposerHeightInch = form.watch("heightInch");
  const proposerWeight = form.watch("proposerWeight");

  const bmi = calculateBMI(height, heightInch, weight);

  const proposerBmi = calculateBMI(
    proposerHeight,
    proposerHeightInch,
    proposerWeight
  );

  //validate bmi of child
  useEffect(() => {
    if (bmi) {
      form.setValue("bmi", Number(bmi.toFixed(2)));
      form.trigger("bmi");
      const isNormalBMI = bmi >= 13.5 && bmi <= 30;
      if (!isNormalBMI) {
        Swal.fire({
          title: "Error",
          html: "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  }, [bmi]);

  //validate proposer bmi
  useEffect(() => {
    if (proposerBmi) {
      form.setValue("proposerBmi", Number(proposerBmi.toFixed(2)));
      form.trigger("proposerBmi");
      const isNormalproposerBmi = proposerBmi >= 13.5 && proposerBmi <= 24.9;
      if (!isNormalproposerBmi) {
        Swal.fire({
          title: "Error",
          html: "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  }, [proposerBmi]);

  useEffect(() => {
    form.setValue("dateOfPregnancy", "");
  }, [isNormalDelivery]);

  return (
    <div>
      <div className="space-y-4">
        <Divider>
          <span className="font-semibold text-sm md:text-lg bg-gray-100 px-4 py-2 rounded">
            स्वास्थ्य सम्बन्धि उद्धोषणा
          </span>
        </Divider>

        <div className=" space-y-2">
          <p>१ (क) तपाईको बच्चाको उचाइ कति छ ?</p>
          <section className="flex gap-2 flex-col md:flex-row">
            <SelectInput
              data={Array.from({ length: 8 }, (_, i) => i + 1).map((item) => {
                return { label: `${item} फिट`, value: item };
              })}
              name="childHeight"
              searchable={false}
              placeholder="Choose feet"
            />

            <SelectInput
              data={Array.from({ length: 11 }, (_, i) => i + 1).map((item) => {
                return { label: `${item} Inch`, value: item };
              })}
              name="childHeightInch"
              searchable={false}
              placeholder="Choose inches"
            />
          </section>

          <SelectInput
            data={Array.from({ length: 44 }, (_, i) => i + 2).map((item) => {
              return { label: `${item} kg`, value: item };
            })}
            name="childWeight"
            label="१.  (ख) तपाईको बच्चाको  वजन कति छ ?"
            placeholder="Choose weight"
          />
        </div>

        <CheckboxGroupInput
          singleSelect
          options={[
            { label: "थियो", value: true },
            { label: "थिएन", value: false },
          ]}
          name="childHadDisease"
          label="२. तिन वर्ष यता तपाईको बच्चलाई एक हप्ता अवधि सम्म रहने कुनै रोग लागेको थियो ?"
        />

        <CheckboxGroupInput
          singleSelect
          options={[
            { label: "थियो", value: true },
            { label: "थिएन", value: false },
          ]}
          name="childHadSurgeryOrAccident"
          label="३.तिन वर्ष यता तपाईको बच्चको कुनै शल्यक्रिया, दुर्घटना तथा सख्त घाईते, चोटपटक, कुनै अंग भंग भएको वा काटी फालेको समेत तथा रोग तथा चोट पटकको कारणले अस्पताल भर्ना भएको वा औषधी उपचार गरिएको थियो ?"
        />

        <CheckboxGroupInput
          singleSelect
          options={[
            { label: "छ", value: true },
            { label: "छैन", value: false },
          ]}
          name="childHadCovid"
          label="४. हाल तपाईको बच्चा कोभिड—१९ को संक्रमणबाट ग्रसित छ ?"
        />

        <CheckboxGroupInput
          singleSelect
          options={[
            { label: "छ", value: true },
            { label: "छैन", value: false },
          ]}
          name="childIsHealthy"
          label="५. तपाईको बच्चा अहिले पूर्ण स्वास्थ्य अवस्थामा छ ?"
        />

        <Divider>
          <span className="font-semibold md:text-lg text-sm bg-gray-100 px-4 py-2 rounded">
            स्वास्थ्य सम्बन्धि उद्धोषणा (प्रस्तावकको)
          </span>
        </Divider>

        <ReviveAdultPolicyForm
          onSubmit={onSubmit}
          gender={gender}
          hadMiscarriage={hasAbortion}
          hasChildren={hasChildren}
          isNormalDelivery={isNormalDelivery}
          isPregnant={isPregnant}
          isProposer={true}
        />
      </div>
    </div>
  );
};

export default ReviveChildPolicy;
